import { useState, useLayoutEffect, useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { generalContext } from "./context/generalContext";
import Header from "./components/layout/header";
import Carousel from "./components/common/carousel";
import WhatsappButton from "./components/common/whatsappButton";
import AnimatedRoutes from "./components/layout/animatedroutes";
import Footer from "./components/layout/footer";
import "./App.scss";
import "animate.css";

// Scroll to top on route change.
const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};

function App() {
  const images = ["pexels-adrien-olichon-2.webp", "pexels-adrien-olichon.webp", "pexels-philipp-birmes.webp"];
  const [imageToDisplay, setImageToDisplay] = useState("");

  useEffect(() => {
    const styles = [
      "color: white",
      "background:  linear-gradient(90deg, #FEE140 0%, #FA709A 100%);",
      "padding: 1vh 100px 10px 100px",
      "text-shadow: 0px 1.5px 2px rgba(0,0,0,0.84);",
    ].join(";");
    const message = "Developed by TonyHermann　竹";
    console.log("%c%s", styles, message);
  }, []);

  return (
    <div className="App">
      <generalContext.Provider value={{ imageToDisplay, setImageToDisplay }}>
        <Router>
          <Wrapper>
            <Header />
            <Carousel images={images} showButtons autoPlay />
            <AnimatedRoutes />
            <Footer />
          </Wrapper>
        </Router>
        <WhatsappButton />
      </generalContext.Provider>
    </div>
  );
}

export default App;
